export const disciplines = [
    "Anthropology",
    "Archaeology",
    "Architecture",
    "Arts",
    "Astronomy",
    "Biology",
    "Chemistry",
    "Computer Science",
    "Data Science",
    "Earth Sciences",
    "Economics",
    "Ecology",
    "Education",
    "Engineering",
    "Environmental Science",
    "Geography",
    "Geology",
    "Health Sciences",
    "History",
    "Law",
    "Linguistics",
    "Mathematics",
    "Meteorology",
    "Oceanography",
    "Philosophy",
    "Physics",
    "Political Science",
    "Psychology",
    "Social ecological systems (SES)",
    "Sociology",
    "Statistics",
    "Theology",
    "Transdisciplinary",
    "Transportation Studies",
    "Urban Planning",
    "Veterinary Science",
    "Other"
];
